import { render } from "./MAFuturePanel.vue?vue&type=template&id=f7bd064e"
import script from "./MAFuturePanel.vue?vue&type=script&lang=ts"
export * from "./MAFuturePanel.vue?vue&type=script&lang=ts"
script.render = render

export default script